import { render, staticRenderFns } from "./ModalEmail.vue?vue&type=template&id=24132e6a&scoped=true&"
import script from "./ModalEmail.vue?vue&type=script&lang=js&"
export * from "./ModalEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmail.vue?vue&type=style&index=0&id=24132e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24132e6a",
  null
  
)

export default component.exports